<template>
  <f7-page>
    <table v-if="sellers" class="listSellerTable">
      <thead>
        <tr>
          <th>Identifiant</th>
          <th>SIREN</th>
          <th>Raison Sociale</th>
          <th>Email</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="seller in sellers" :key="seller.IdSeller">
          <td>{{ seller.SellerIdentifier }}</td>
          <td>{{ seller.Siren }}</td>
          <td>{{ seller.SocialReason }}</td>
          <td>{{ seller.Email }}</td>
          <td>{{ dateFormat(seller.Date) }}</td>
        </tr>
      </tbody>
    </table>
  </f7-page>
</template>
<script>
/** @author JPR 09/05/2022
* @brief Liste des seller simplifiée
*/

import moment from 'moment'

export default {
  name: 'ListSellersFromApplicationForm',
  components: {
  },
  data () {
    return {
      sellers: []
    }
  },
  created () {
    let that = this
    this.$engine.services.suppliers.getDocuments()
    .then(resp => {
      if (resp && resp.data && resp.data.Sellers && resp.data.Sellers.length) {
        that.sellers = resp.data.Sellers
      }
    })
    .catch(err => {
      that.$f7.hidePreloader()
      console.log(err)
    })
  },
  methods: {
    dateFormat (str) {
      return moment(str).format('DD/MM/yyyy HH:mm:ss')
    }
  }
}
</script>
<style>
.listSellerTable {
  border: 1px solid black;
  border-collapse: separate;
  border-spacing: 0;
}

.listSellerTable th, .listSellerTable td {
  border: 1px solid black;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// ListSellersFromApplicationForm.vue?3636168c